import { createFileRoute } from '@tanstack/react-router'
import { CustomerDashboardPage } from '@/features/customer/pages/dashboard'

export const Route = createFileRoute('/_authenticated/customer/')({
  component: CustomerDashboardPage,
})
